<app-page-header>
  <div class="page-heading">
    <!-- <div class="page-heading-icon">
      <i class="fa-solid fa-message"></i>
    </div> -->

    <div>
      <h3>Feedback</h3>
      <p>See how people rated AI answers and review the ones marked not helpful.</p>
    </div>
  </div>
</app-page-header>

<section class="feedback-section">
  <div class="feedback-container">

    <!-- =====================================================
         TOP TOOLBAR
    ====================================================== -->
    <div class="feedback-toolbar">

      <!-- Summary -->
      <div class="feedback-summary">
        <div class="summary-icon">
          <i class="fa-solid fa-chart-simple"></i>
        </div>

        <div class="summary-content">
          <span>Total Feedback</span>
          <strong>{{ feedbackData.length }}</strong>
        </div>
      </div>

      <!-- Search -->
      <div class="search-box">
        <i class="fa-solid fa-magnifying-glass search-icon"></i>

        <input
          type="text"
          class="search-input"
          [(ngModel)]="search"
          (keyup)="searchInList.next($event)"
          placeholder="Search feedback..."
          aria-label="Search feedback"
        />

        @if (search) {
          <button
            type="button"
            class="clear-search"
            aria-label="Clear search"
            (click)="search = ''; searchInList.next($event)"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        }
      </div>
    </div>


    <!-- =====================================================
         FEEDBACK CARD
    ====================================================== -->
    <div class="feedback-card">

      <!-- Table Header -->
      <!-- <div class="table-header">

        <div class="table-heading">
          <div class="table-heading-icon">
            <i class="fa-solid fa-comments"></i>
          </div>

          <div>
            <h4>Feedback Responses</h4>

            @if (feedbackData.length > 0) {
              <p>
                Showing
                <strong>{{ feedbackData.length }}</strong>
                {{ feedbackData.length === 1 ? "entry" : "entries" }}
              </p>
            } @else {
              <p>Review questions, answers and user feedback</p>
            }
          </div>
        </div>

        <div class="table-status">
          <span class="status-dot"></span>
          <span>Feedback Records</span>
        </div>
      </div> -->


      <!-- =================================================
           TABLE
      ================================================== -->
      <div class="table-wrapper">

        <table class="feedback-table">

          <thead>
            <tr>

              <!-- Question -->
              <th class="question-column">
                <div class="th-content">
                  <span class="th-icon question">
                    <i class="fa-solid fa-circle-question"></i>
                  </span>
                  <span>Question</span>
                </div>
              </th>

              <!-- Answer -->
              <!-- <th class="answer-column">
                <div class="th-content">
                  <span class="th-icon answer">
                    <i class="fa-solid fa-comment-dots"></i>
                  </span>
                  <span>Answer</span>
                </div>
              </th> -->

              <!-- Feedback -->
              <th class="feedback-column">
                <div class="th-content">
                  <span class="th-icon accuracy">
                    <i class="fa-solid fa-thumbs-up"></i>
                  </span>
                  <span>Feedback</span>
                </div>
              </th>

              <!-- Comments -->
              <th class="comments-column">
                <div class="th-content">
                  <span class="th-icon comments">
                    <i class="fa-solid fa-message"></i>
                  </span>
                  <span>Comments</span>
                </div>
              </th>

              <!-- Source -->
              <th class="source-column">
                <div class="th-content">
                  <span class="th-icon source">
                    <i class="fa-solid fa-file-lines"></i>
                  </span>
                  <span>Source Document</span>
                </div>
              </th>

              <!-- Date -->
              <th class="date-column">
                <div class="th-content">
                  <span class="th-icon date">
                    <i class="fa-regular fa-calendar"></i>
                  </span>
                  <span>Created</span>
                </div>
              </th>

            </tr>
          </thead>


          <tbody>

            <!-- =================================================
                 EMPTY STATE
            ================================================== -->
            @if (feedbackData.length === 0) {

              <tr>
                <td colspan="6">

                  <div class="no-data">

                    <div class="no-data-icon">
                      <i class="fa-regular fa-comments"></i>
                    </div>

                    <h5>No feedback found</h5>

                    <p>
                      There are no feedback responses available.
                    </p>

                  </div>

                </td>
              </tr>

            }


            <!-- =================================================
                 FEEDBACK ROW
            ================================================== -->
            @for (item of feedbackData; track item) {

              <tr>

                <!-- =================================================
                     QUESTION
                ================================================== -->
                <td class="question-cell">

                  <div class="question-wrapper">

                    <span class="mobile-column-label">
                      Question
                    </span>

                    <p class="question-text">
                      {{ item.question }}
                    </p>

                  </div>

                </td>


                <!-- =================================================
                     ANSWER
                ================================================== -->
                <!-- <td class="answer-cell">

                  <div class="answer-wrapper">

                    <span class="mobile-column-label">
                      Answer
                    </span>

                    <div
                      class="answer-preview"
                      [innerHTML]="getShortAnswer(item.answer)"
                    ></div>

                    @if (item.answer?.length > 26) {

                      <button
                        type="button"
                        class="read-more"
                        (click)="openAnswerDialog(item.answer)"
                      >
                        <i class="fa-regular fa-eye"></i>
                        <span>Read More</span>
                      </button>

                    }

                  </div>

                </td> -->


                <!-- =================================================
                     FEEDBACK
                ================================================== -->
                <td class="feedback-cell">

                  <span class="mobile-column-label">
                    Feedback
                  </span>

                  <span
                    class="feedback-badge"
                    [ngClass]="{
                      like: item.feedback === 'LIKE',
                      unlike: item.feedback === 'UNLIKE'
                    }"
                  >

                    <span class="badge-icon">

                      <i
                        class="fa"
                        [ngClass]="
                          item.feedback === 'LIKE'
                            ? 'fa-check'
                            : 'fa-xmark'
                        "
                      ></i>

                    </span>

                    <span>
                      {{ item.feedback === "LIKE" ? "LIKE" : "UNLIKE" }}
                    </span>

                  </span>

                </td>


                <!-- =================================================
                     COMMENTS
                ================================================== -->
                <td class="comments-cell">

                  <div
                    class="comments-content"
                    [title]="item.comments || ''"
                  >

                    <span class="mobile-column-label">
                      Comments
                    </span>

                    <div class="comment-display">

                      <i class="fa-regular fa-comment"></i>

                      <span>
                        {{ item.comments || "No comments" }}
                      </span>

                    </div>

                  </div>

                </td>


                <!-- =================================================
                     SOURCE DOCUMENT
                ================================================== -->
                <td class="source-cell">

                  <span class="mobile-column-label">
                    Source Document
                  </span>

                  <div
                    class="source-document"
                    [pTooltip]="getSourceDocDisplay(item.source_doc)"
                    tooltipPosition="top"
                    [showDelay]="300"
                  >

                    <div class="source-icon">
                      <i class="fa-solid fa-file-lines"></i>
                    </div>

                    <span>
                      {{ getSourceDocDisplay(item.source_doc) }}
                    </span>

                  </div>

                </td>


                <!-- =================================================
                     DATE
                ================================================== -->
                <td class="date-cell">

                  <span class="mobile-column-label">
                    Created
                  </span>

                  <div class="date-wrapper">

                    <span class="date-icon">
                      <i class="fa-regular fa-calendar"></i>
                    </span>

                    <div>

                      <strong>
                        {{ item.created_at | date : "MM/dd/yyyy" }}
                      </strong>

                      <span>
                        Feedback date
                      </span>

                    </div>

                  </div>

                </td>

              </tr>

            }

          </tbody>

        </table>

      </div>

    </div>

  </div>


  <!-- =====================================================
       ANSWER DIALOG
  ====================================================== -->
  <p-dialog
    header="Full Answer"
    [(visible)]="showAnswerDialog"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{
      width: 'min(850px, 92vw)',
      'max-height': '85vh'
    }"
    styleClass="feedback-answer-dialog"
  >

    <div class="answer-dialog-content">

      <div class="dialog-answer-header">

        <div class="dialog-answer-icon">
          <i class="fa-solid fa-comment-dots"></i>
        </div>

        <div class="dialog-answer-heading">
          <h5>Answer Details</h5>
          <p>
            Complete response generated for this question
          </p>
        </div>

      </div>

      <div
        class="answer-content"
        [innerHTML]="selectedAnswer"
      ></div>

    </div>

  </p-dialog>

</section>
